import React, { FC } from 'react';
import { CandidateProfileHeader } from '@src/containers/CandidateProfileHeader';
import { CandidateProfileDataItems } from '@src/containers/CandidateProfileDataItems';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { trackEvent } from '@src/metrics';
import { MessageThreadStateEnum } from '@src/graphql/generated';
import { CandidateProfileAction } from '@src/containers/CandidateProfileHeader/interfaces/candidateProfileAction.interface';
import { InboxCandidateProfileProps } from './props';
import './styles.scss';

export const InboxCandidateProfile: FC<InboxCandidateProfileProps> = ({
  onChatClose,
  markUnread,
  onChatArchive,
  messageThread,
}) => {
  const application = messageThread.application;
  const threadId = messageThread.id;
  const opening = messageThread.opening;
  const isUnread = messageThread.isUnread;
  const user = messageThread.user;

  function handleChatArchive() {
    onChatArchive();

    trackEvent({
      context: MetricContext.CHAT,
      interaction: MetricAction.ARCHIVE_CHAT,
      payload: {
        'Application Id': application?.id,
        'Event Source': MetricEventSource.CANDIDATE_PROFILE_ARCHIVE_ACTION,
        'Opening Id': opening?.id,
        'Previous Context': MetricContext.CHATS,
        'Thread Id': threadId,
      },
    });
  }

  function handleMarkAsUnread() {
    markUnread();

    trackEvent({
      context: MetricContext.CHAT,
      interaction: MetricAction.MARK_CHAT_AS_UNREAD,
      payload: {
        'Application Id': application?.id,
        'Event Source': MetricEventSource.CANDIDATE_PROFILE_MARK_AS_UNREAD_ACTION,
        'Opening Id': opening?.id,
        'Previous Context': MetricContext.CHATS,
        'Thread Id': threadId,
      },
    });
  }

  const actions: CandidateProfileAction[] = [
    {
      action: handleChatArchive,
      destructive: true,
      label: 'Delete',
    },
  ];

  if (!isUnread) {
    actions.unshift({
      action: handleMarkAsUnread,
      label: 'Mark as unread',
    });
  }

  if (messageThread.recruiterState === MessageThreadStateEnum.OPEN) {
    actions.unshift({
      action: onChatClose,
      label: 'Close',
    });
  }

  return (
    <div className="inbox-candidate-profile">
      <CandidateProfileHeader
        actions={actions}
        applicationId={application?.id}
        className="inbox-candidate-profile__header"
        metricsContext={MetricContext.CHATS}
        openingId={opening?.id}
        user={user}
      />

      <div className="inbox-candidate-profile__body">
        <div className={'inbox-candidate-profile__body-title'}>Profile</div>

        <CandidateProfileDataItems applicationId={application?.id} user={user} />
      </div>
    </div>
  );
};
